import { Avatar } from '@mui/material'
import { PrivateSpaceListItemTitle } from './private-space-list-item-title'
import { MenuIcon } from '$common/icons/menu'
import { ChatListItem } from '../chat-list-item'
import { nothing } from '$func/utils'
import { BadgeWrapper } from '$common/badge/styled-badge'

interface Props {
  hasDivider?: boolean
  onClick?: () => unknown
  onSecondaryActionIconClick?: () => unknown
  onContextMenu?: (e: MouseEvent) => void
  selected?: boolean
}

export function PrivateSpaceListItemWithStatus({
  hasDivider = true,
  onClick = nothing,
  onSecondaryActionIconClick = nothing,
  onContextMenu = nothing,
  selected = false,
}: Props) {
  return (
    <ChatListItem
      avatarComponent={
        <BadgeWrapper selected={selected}>
          <Avatar src="assets/svg/private-space.svg" />
        </BadgeWrapper>
      }
      primaryText={<PrivateSpaceListItemTitle />}
      SecondaryActionIcon={MenuIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
    />
  )
}
